//Imports node_modules
import React from "react"

//Imports Css
import './BottomBar.css'

//Imports Components
import NextButton from "../topBar/nextButton/NextButton"
import BackButton from "../topBar/backButton/BackButton"

//Layout de navegação na parte inferior da aplicação
const BottomBar = (params) => {

    let type = params.type ? params.type : ''


    function renderBackBtn() {
        switch (type) {
            case 'userPage':
                return (<div>

                </div>)
            case 'dossiers_List':
                return (<div className="fixedNav">
                    <BackButton backText={params.backText ? params.backText : "Voltar"} click={params.backbtnClick} cancelar></BackButton>
                </div>);
            default:
                return (<div className="fixedNav">
                    <BackButton backText={params.backText ? params.backText : "Voltar"} click={params.backbtnClick} cancelar></BackButton>
                </div>);
        }
    }

    function renderNextBtn() {
        switch (type) {
            case 'userPage':
                return (<NextButton isDisabled={params.isDisabled ? params.isDisabled : false} nextText={params.nextText} click={params.nextBtnClick} red></NextButton>);
            case 'dossiers_List':
                return (<NextButton isDisabled={params.isDisabled ? params.isDisabled : false} nextText={params.nextText} click={params.nextBtnClick} blue></NextButton>);
            default:
                return (<NextButton isDisabled={params.isDisabled ? params.isDisabled : false} nextText={params.nextText} click={params.nextBtnClick} green></NextButton>);
        }
    }

    return (
        <div className="containerNav">
            {renderBackBtn()}
            <div className="flex-itemNav">
                {renderNextBtn()}
            </div>
        </div>
    )
}

export default BottomBar